/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Clear_MarkerInputs */

const en_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Captions cleared`)
};

const fr_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titres effacés`)
};

const de_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel entfernt`)
};

const it_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli cancellati`)
};

const ru_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры очищены`)
};

const es_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos eliminados`)
};

const zh_cn2_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕已清除`)
};

const ja_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕承認済み`)
};

const hi_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन साफ़ हो गए`)
};

const pt_pt2_live_caption_clear_marker = /** @type {(inputs: Live_Caption_Clear_MarkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas removidas`)
};

/**
* | output |
* | --- |
* | "Captions cleared" |
*
* @param {Live_Caption_Clear_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_clear_marker = /** @type {((inputs?: Live_Caption_Clear_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Clear_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_clear_marker(inputs)
	if (locale === "de") return de_live_caption_clear_marker(inputs)
	if (locale === "it") return it_live_caption_clear_marker(inputs)
	if (locale === "ru") return ru_live_caption_clear_marker(inputs)
	if (locale === "es") return es_live_caption_clear_marker(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_clear_marker(inputs)
	if (locale === "ja") return ja_live_caption_clear_marker(inputs)
	if (locale === "hi") return hi_live_caption_clear_marker(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_clear_marker(inputs)
	return en_live_caption_clear_marker(inputs)
});